import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { AuditProgramResponse } from 'app/model/audit-program-response-dto';
import { ComboPopulation } from 'app/model/combo-population';
import { CommonDTO } from 'app/model/common-dto';
import { ManageAuditProgramDto } from 'app/model/manage-audit-program-dto';
import { ManageAuditProgramListSearch } from 'app/model/manage-audit-program-list-search';
import { ManageAuditProgarmService } from 'app/service/manage-audit-progarm-service';
import { CustomMessages } from '../custom-messages/custom-messages';
import { EasyDialog } from '../easy-dialog/easy-dialog';

@Component({
  selector: 'app-auditee-auditor',
  templateUrl: './auditee-auditor.component.html',
  styleUrls: ['./auditee-auditor.component.scss'],
  providers: [TranslatePipe],
})
export class AuditeeAuditorComponent implements OnInit {
  auditProgramResponse = new AuditProgramResponse();
  manageAuditProgramListSearch: ManageAuditProgramListSearch = new ManageAuditProgramListSearch();
  commonDto = new CommonDTO();
  comboPopulation = new ComboPopulation();
  selectedChoice: string;
  callingFrom: string;
  parsedJson: any;
  showAuditor: boolean = false;
  selectedAuditor: boolean = false;
  selectedAuditee: boolean = false;
  fileArray: File[] = [];
  configureSiteForm = new FormGroup({
    siteName: new FormControl('', [Validators.required]),
    auditName: new FormControl('', [Validators.required]),
    auditeeName: new FormControl('', [Validators.required]),
    auditorName: new FormControl(true, [Validators.required]),
  });
  constructor(
    private datePipe: DatePipe,
    private manageAuditProgarmService: ManageAuditProgarmService,
    public dialog: EasyDialog,
    private dialogRef: MatDialogRef<AuditeeAuditorComponent>,
    private customMessage: CustomMessages,
    private ts: TranslatePipe,
    @Inject(MAT_DIALOG_DATA) public recievedData: any
  ) {
    this.manageAuditProgramListSearch = recievedData.searchList;
  }

  ngOnInit() {
    this.getRole();
  }

  getType(type) {
    if (type == 'Audit') {
      this.selectedChoice = 'A';
      this.configureSiteForm.controls.auditName.patchValue([this.selectedChoice]);
    } else {
      this.selectedChoice = 'S';
      this.configureSiteForm.controls.siteName.patchValue([this.selectedChoice]);
    }
  }

  getRole() {
    this.manageAuditProgarmService.exportRole(this.manageAuditProgramListSearch).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.comboPopulation = this.parsedJson;
        if (this.comboPopulation[0].name == '262') {
          this.callingFrom = 'Auditee';
          this.showAuditor = false;
        } else {
          this.callingFrom = 'Auditor';
          this.selectedAuditor = true;
          this.showAuditor = true;
        }
      },
      error => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  closePopup() {
    this.dialogRef.close();
    return false;
  }

  saveButton() {
    if (this.configureSiteForm.status == 'INVALID') {
      if (this.configureSiteForm.get('siteName').value == '') {
        if (this.configureSiteForm.get('auditName').value == '') {
          this.customMessage.showErrorMessage('cams.label.common.radio.audit.site', '');
          return false;
        }
      }
      if (
        this.configureSiteForm.get('auditeeName').value == false &&
        this.configureSiteForm.get('auditorName').value == false
      ) {
        this.customMessage.showErrorMessage('cams.label.common.roleType', '');
        return false;
      }
    }
    if (this.callingFrom == 'Auditor') {
      if (this.selectedAuditee == true && this.selectedAuditor == false) {
        this.callingFrom = 'Auditee';
      } else if (this.selectedAuditee == false && this.selectedAuditor == true) {
        this.callingFrom = 'Auditor';
      } else {
        this.callingFrom = 'Auditor,Auditee';
      }
    }
    //(this.callingFrom + "calling form");
    this.manageAuditProgramListSearch.callingFrom = this.callingFrom;
    this.manageAuditProgramListSearch.callingType = this.selectedChoice;
    this.manageAuditProgarmService.downloadExcel(this.manageAuditProgramListSearch).subscribe(
      data => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        var dateTimeStr = this.datePipe.transform(new Date(), 'ddMMyyyyhhmmss');
        if (this.manageAuditProgramListSearch.callingType == 'A')
          link.download = 'Audit_User_Permission_' + Date.now() + '.xlsx';
        else link.download = 'Site_User_Permission_' + Date.now() + '.xlsx';

        link.click();
        this.closePopup();
      },
      error => {
        this.closePopup();
        if (error.error.msgId == null) {
          this.customMessage.showErrorMessage('cams.label.common.noRecordFound', '');
        } else {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      }
    );
  }
}
